// Events related to plan year management
export const PLAN_YEAR_EVENTS = {
  CHANGE_PLAN_YEAR: 'changePlanYear',
  OPEN_RENEW_EMPLOYER_MODAL: 'openRenewEmployerModal'
}
